'use strict'

import ApiClient from './ApiClient'

export default class MergePersonRepository {
  // TODO 共通化
  setMgmtParam (isMgmt, params) {
    params = params || {}

    if (isMgmt) {
      params.is_mgmt = '1' // TODO this.app_flag.ON
    }

    return params
  }

  /**
   * 人物統合：統合情報にある名刺人物を統合します。
   * @param data 統合情報
   * @returns {*}
   */
  merge (data) {
    return ApiClient().post(`/merge-persons`, data)
  }

  /**
   * 未判定人物一覧を取得します。
   * @param params
   */
  getList (params) {
    return ApiClient().get(`/merge-persons`, { params })
  }

  /**
   * 検索条件に一致する人物一覧を取得します。
   * @param {object} data 検索条件のbody情報
   * @returns {*}
   */
  postSearch (data) {
    // クエリで指定するデータを移動する
    const params = {
      page: data.page,
      sort_item: data.sort_item,
      direction: data.direction
    }
    delete data.page
    delete data.sort_item
    delete data.direction

    return ApiClient().post(`/merge-persons/all`, data, { params })
  }

  /**
   * 同一人物判定対象情報を取得します。
   * @param {string|int} person_id 人物ID
   * @returns {*}
   */
  get (person_id) {
    return ApiClient().get(`/merge-persons/${person_id}`)
  }

  /**
   * 指定されたIDの名刺人物を判定済みにします。
   * @param {string|int} person_id 人物ID
   * @returns {*}
   */
  complete (person_id) {
    return ApiClient().put(`/merge-persons/${person_id}`)
  }

  /**
   * 人物分割：名刺人物から名刺情報を抽出して新しい人物を作成します。
   * @param {object} data
   * @returns {*}
   */
  extract (data) {
    return ApiClient().post(`/merge-persons/extraction`, data)
  }

  /**
   * 指定された人物IDの最新名刺情報（と関連情報）を取得します。
   * @param {string|int} person_id 人物ID
   * @param {bool} isMgmt 管理モードフラグ
   * @returns {*}
   */
  getLatestBcard (person_id, isMgmt) {
    const params = this.setMgmtParam(isMgmt)
    // 名寄せ情報取得のフラグを立てる
    params.get_judgement = '1'
    return ApiClient().get(`/persons/${person_id}/bcards/0`, { params })
  }
}



// WEBPACK FOOTER //
// ./src/repositories/MergePersonRepository.js